import { RecordDataSource } from "../../../records/grids";
import { percentageValueGetterFactory } from "../../../records/grids/cells/valueGetters";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";

import { vsObjectName as machineConfigurationTypeName } from "./machineConfigurationType";

export const vsObjectName = "machineConfigurationTypeGameConfiguration";

const url = "/api/machines/MachineConfigurationTypeGameConfiguration";

machineGameConfigurationTypeGameConfigurationConfig.$inject = [
  RecordGridViewServiceProviderName,
];
export function machineGameConfigurationTypeGameConfigurationConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
    (
      recordGridViewService: RecordGridViewService,
      columnDefinitionService: ColumnDefinitionService,
      serverUtility: ServerUtility
    ): GridConfiguration => {
      const configurationTypeGridConfiguration =
        recordGridViewService.getGridConfiguration(
          machineConfigurationTypeName
        )!;
      return {
        gridDataSource: new RecordDataSource(serverUtility, url),
        columns: [
          columnDefinitionService.getStringColDef({
            header: "Denomination",
            field: "MachineDenominationName",
          }),
          columnDefinitionService.getStringColDef({
            header: "Theme",
            field: "MachineThemeName",
          }),
          columnDefinitionService.getStringColDef({
            field: "Paylines",
          }),
          columnDefinitionService.getNumberColDef({
            field: "RTPWIncrement",
            header: "RTP w/ Increment",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "FirstRTPWIncrement",
            header: "First RTP w/ Increment",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "MaxRTPWIncrement",
            header: "Max RTP w/ Increment",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getStringColDef({
            field: "Paytable",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MaxBet",
          }),
          columnDefinitionService.getNumberColDef({
            field: "Par",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "ParSheetPar",
            header: "Par Sheet Par",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "ProgressiveIncrement",
            header: "Progressive Increment",
            valueGetter: percentageValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "TopAward",
            header: "Top Award",
          }),
          columnDefinitionService.getStringColDef({
            field: "Variation",
          }),
          columnDefinitionService.getBooleanColDef({
            header: "Exclude from calculations",
            field: "ExcludeFromCalculations",
          }),
          /* TODO - fill in client specific game configuration fields */
          ...(configurationTypeGridConfiguration.columns ?? []),
        ],
        defaultSort: RecordGridViewService.combineSort(
          configurationTypeGridConfiguration.defaultSort,
          "Order"
        ),
        namePlural: "Game Configurations",
        nameSingular: "Game Configuration",
      };
    },
  ]);
}
